import changeFeedHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/changeFeed-header.png';
import changeFeedSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/changeFeed-section1.png';
import changeFeedSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/changeFeed-section2.png';
import changeFeedSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/changeFeed-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_SF_CHANGE_FEED: PageblockData = {
  headerData: {
    headerText: 'Stay ahead with real-time change tracking for your Salesforce org',
    subHeaderText:
      'Monitor every change, receive instant alerts for updates, and gain a unified view of all modifications across your Salesforce environments.',
    imgSrc: changeFeedHeader,
    imgAlt: 'Change feed header img',
    name: 'Change Feed',
  },
  pageTitle: `Achieve complete visibility and control with Sweep´s Salesforce change feed`,
  section1: {
    imgSrc: changeFeedSection1,
    imgAlt: 'Change feed section img',
    title: 'Track changes made in your Salesforce org, forever',
    content:
      'Monitor and record every modification within your Salesforce environment in real-time, ensuring a permanent and comprehensive audit trail.',
  },
  section2: {
    imgSrc: changeFeedSection2,
    imgAlt: 'Change feed section 2 img',
    title: 'Alerts for unwanted changes',
    content:
      'Receive immediate notifications for critical or unauthorized updates, enabling prompt response to potential issues.',
  },
  section3: {
    imgSrc: changeFeedSection3,
    imgAlt: 'Change feed section 3 img',
    title: 'Track across all your orgs in one place',
    content:
      'Consolidate change tracking across multiple Salesforce organizations into a single, unified view for streamlined oversight.',
  },
};
